import React from 'react'
import CustomLink from '../Dashboard/CustomLink'
import { useIntl } from "react-intl"

const DashboardLinks = () => {

  const intl = useIntl();
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-8 bg-gray-200 flex-wrap text-center">
        <CustomLink to='/app/dashboard' label={intl.formatMessage({ id: "app.privateMenu.dashboard", defaultMessage: 'Home' })} />
        <CustomLink to='/app/documents' label={intl.formatMessage({ id: "app.privateMenu.documents", defaultMessage: 'Documents' })} />
        <CustomLink to='/app/catalog' label={intl.formatMessage({ id: "app.privateMenu.colorCards", defaultMessage: 'Color Cards' })} />
        <CustomLink to='/app/datasheets' label={intl.formatMessage({ id: "app.privateMenu.datasheets", defaultMessage: 'Datasheets' })} />
      </div>
    </>
  )
}

export default DashboardLinks